import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export default function NotFound() {
  const c = useCopy("notFound");
  const lp = useLp();
  return (
    <>
      <SEO title={c.seoT} description={c.seoD} path="/404/" />
      <section className="container-site section-gap" data-testid="not-found-page">
        <div className="max-w-2xl">
          <p className="font-mono text-6xl sm:text-7xl font-medium text-terracotta tracking-tight">404</p>
          <h1 className="mt-4 text-3xl sm:text-4xl font-bold leading-tight">{c.h1}</h1>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">{c.text}</p>
          <nav className="mt-8 grid sm:grid-cols-2 gap-3" aria-label={c.navAria}>
            {c.links.map((l) => (
              <Link key={l.href} to={lp(l.href)} data-testid={`404-link-${l.href.split("/")[1]}`}
                    className="card-technical p-5 text-[15px] font-medium text-ink hover:text-terracotta transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
